/*
  Below is used on organisation images
*/

export const resizeImg = (url, size) => {
  if (!url) {
    throw Error("Argument 'url' passed with no value");
  }

  const newUrl = url.split("/");
  newUrl.splice(newUrl.length - 1, 0, size);
  return newUrl.join("/");
};

/*
  Below is used on blog articles from strapi
*/

let CLOUDFRONT_URL;

if (process.env.TARGET_ENV === "nz") {
  CLOUDFRONT_URL = "cdn.seekvolunteer.co.nz";
} else {
  CLOUDFRONT_URL = "cdn.volunteer.com.au";
}

export const resizeImgCloudFront = (imgUrl: string, size: string): string => {
  const urlArray = imgUrl.split("/");

  const result = [...urlArray];
  result.splice(urlArray.length - 1, 0, size);
  result[2] = CLOUDFRONT_URL;

  return result.join("/");
};
